import { render } from "./Award_journey.vue?vue&type=template&id=32e25cf2&scoped=true"
import script from "./Award_journey.vue?vue&type=script&lang=js"
export * from "./Award_journey.vue?vue&type=script&lang=js"

import "./Award_journey.vue?vue&type=style&index=0&id=32e25cf2&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\alexg\\Desktop\\martech\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32e25cf2"]])

export default __exports__